import { Component, OnInit, ViewChild, SimpleChanges, Input } from '@angular/core';
import { DocumentService } from '../../services/document.service';
import { JobService } from '../../services/jobs/job.service';
import { FormGroup, FormBuilder, FormControl, FormArray } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { LearnerService } from '../../services/learner.service';
import * as _ from 'lodash';
import { MatTableDataSource, MatPaginator, MatSort, MatSnackBar } from '@angular/material';
import { SignaturePadComponent } from '../../commons/signature-pad/signature-pad.component';
import { Observable } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { saveAs } from "file-saver";
import * as _moment from 'moment';
import { FileGenerationService } from '../../services/file-generation.service';
import { CourseUnitsService } from '../../services/course-units.service';
import { PortfolioService } from '../../services/portfolio/portfolio.service';
import { MAT_MOMENT_DATE_FORMATS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
const moment = _moment;


@Component({
  selector: 'app-iv-assessment-form',
  templateUrl: './iv-assessment-form.component.html',
  styleUrls: ['./iv-assessment-form.component.scss'],
  providers: [
    // `MomentDateAdapter` and `MAT_MOMENT_DATE_FORMATS` can be automatically provided by importing
    // `MatMomentDateModule` in your applications root module. We provide it at the component level
    // here, due to limitations of our example generation script.
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
  ],
})

export class IvAssessmentFormComponent implements OnInit {

  @Input('units') allUnits
  @Input('job') jobId;
  @Input('listOfSample') sampleList;
  iqaVerification
  displayData
  unitTitle
  unitId
  assignmentTitle
  currentUser
  allLearners: any = []
  learnerForm
  documentForm
  pageSizeOptions: number[] = [25, 50, 100];
  dataSource: MatTableDataSource<any>;
  paginator: MatPaginator;
  sort: MatSort;
  displayedColumns = ['unit', 'assignment', 'action'];

  internalSign = false
  assessorSign = false
  leadSign = false
  courseType
  assignmentId
  isEdit = false
  editDetails
  instructorsList = []
  selectedAssessors = []
  selectedVerifieres = []
  unitList = []
  singleJob
  unitString
  loading = false
  assessorNames = []
  IQANames = []
  displayAssessor = []
  displayVerifier = []
  courseId: any;
  docId: any;
  updatedSample = []
  internalDate: Date;
  isDisplay = true
  isIQA
  isTrainer
  user: any;
  isClient: boolean = false
  @ViewChild(MatSort, { static: true }) set matSort(ms: MatSort) {
    this.sort = ms;
    this.setDataSourceAttributes();
  }
  @ViewChild(MatPaginator, { static: true }) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }
  setDataSourceAttributes() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
  constructor(
    public documentService: DocumentService,
    public formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private _learnerService: LearnerService,
    public dialog: MatDialog,
    public _snackBar: MatSnackBar,
    public jobService: JobService,
    public _fileGenerationService: FileGenerationService,
    public unitService: CourseUnitsService,
    public _portfolioService: PortfolioService,
  ) {
    this.user = JSON.parse(localStorage.getItem('userRoles'))
    this.dataSource = new MatTableDataSource();
    // this.documentService.getAssignmentObservable().subscribe((res: any) => {
    //   console.log("response of all data which is ready to display", res.data);
    //   this.displayData = res.data
    //   this.createForm(res.data)
    // })


    this.activatedRoute.params.subscribe(qparams => {
      console.log("what is qparams data", qparams);
      //this.unitTitle = qparams.unitTitle
      //this.assignmentTitle = qparams.assignment
      this.jobId = qparams.jobid
      //this.unitId = qparams.unitId
      //this.courseType = qparams.courseType
      //this.assignmentId = qparams.assignmentId
    })

  }



  ngOnInit() {
    this.user = JSON.parse(localStorage.getItem('userRoles'))
    if (this.user && this.user.isClient) {
      console.log("call this or not", this.user);
      this.isClient = true
    }
    // console.log("this user role current========>",this.user)
    this.createForm()
    this.createLearnerForm()
    // this.getLearners(this.jobId)
    this.createFinalForm()
    this.getIqaFormValue()
    this.getJobDetails()
  }


  ngOnChanges(changes: SimpleChanges): void {
    if (changes.allUnits && changes.allUnits.currentValue) {
      //this.unitList = changes.allUnits.currentValue
      //console.log(" all units list in assessment form", this.unitList);
      //this.unitString = Array.prototype.map.call(this.unitList, function (item) { return item.unitNo; }).join(",");
      //console.log("what is the unit string", this.unitString);
    }
    if (changes.job && changes.job.currentValue) {
      this.jobId = changes.job.currentValue
      this.getIqaFormValue()
    }

    if (changes.sampleList && changes.sampleList.currentValue) {
      this.updatedSample = changes.sampleList.currentValue
      this.isDisplay = true
      this.createLearnerForm(this.updatedSample)
    }
  }



  createForm(details?) {

    //console.log("what is in this details", details.unitName ? details);

    this.iqaVerification = new FormGroup({
      programmeTitle: new FormControl((details && details.programmeTitle) ? details.programmeTitle : ''),
      unitName: new FormControl((details && details.unitName) ? details.unitName : this.unitString),
      assignmentTitle: new FormControl(this.assignmentTitle ? this.assignmentTitle : ''),
      assessor: new FormControl(this.assessorNames ? this.assessorNames : []),
      verifier: new FormControl((this.IQANames) ? this.IQANames : []),
      assignmentId: new FormControl(this.assignmentId),
      checklist1: new FormControl((details && details.checklist1) ? details.checklist1 : false),
      checklist2: new FormControl((details && details.checklist2) ? details.checklist2 : false),
      checklist3: new FormControl((details && details.checklist3) ? details.checklist3 : false),
      checklist4: new FormControl((details && details.checklist4) ? details.checklist4 : false),
      checklist5: new FormControl((details && details.checklist5) ? details.checklist5 : false),
      checklist6: new FormControl((details && details.checklist6) ? details.checklist6 : false),
    })
    if(this.isClient) this.iqaVerification.disable()
    if (this.user && (this.isTrainer)) {
      this.iqaVerification.disable()
    }
    if (this.user && (this.isIQA || this.user.isAdmin)) {
      this.iqaVerification.enable()
    }
  }


  createLearnerForm(details?) {
    this.learnerForm = new FormGroup({
      learners: this.formBuilder.array(this.multipleLearners(details))
    })
    if(this.isClient) this.learnerForm.disable()
    console.log("value of form", this.learnerForm.value);
    if (this.user && (this.isTrainer)) {
      this.learnerForm.disable()
    }
    if (this.user && (this.isIQA || this.user.isAdmin)) {
      this.learnerForm.enable()
    }
  }

  createFinalForm(details?) {
    this.documentForm = new FormGroup({
      comment: new FormControl((details && details.comment) ? details.comment : ''),
      actions: this.formBuilder.array(this.multipleActions((details && details.actions ? details.actions : []))),
      internalSign: new FormControl((details && details.internalSign) ? details.internalSign : ''),
      internalDate: new FormControl((details && details.internalDate) ? new Date(details.internalDate) : ''),
      assessorSign: new FormControl((details && details.assessorSign) ? details.assessorSign : ''),
      assessorDate: new FormControl((details && details.assessorDate) ? new Date(details.assessorDate) : ''),
      leadSign: new FormControl((details && details.leadSign) ? details.leadSign : ''),
      leadDate: new FormControl((details && details.leadDate) ? new Date(details.leadDate) : '')
    })
    if(this.isClient) this.documentForm.disable()
    if (this.user && (this.user.isTrainer || this.user.isMp)) {
      this.documentForm.get('comment').disable()
      this.documentForm.get('actions').disable()
      this.documentForm.get('internalSign').disable()
      this.documentForm.get('internalDate').disable()
      this.documentForm.get('leadSign').disable()
      this.documentForm.get('leadDate').disable()
    }
    if (this.user && this.user.isClient) {
      this.documentForm.disable()
    }
    if (this.user && (this.isIQA || this.user.isAdmin)) {
      this.documentForm.enable()
    }
  }


  get learnerDetails() { return <FormArray>this.learnerForm.get('learners'); }
  multipleLearners(learners?) {
    console.log("all learners array", learners);

    if (learners && learners.length) {
      let unitArray = []
      _.forEach(learners, async (unit) => {
        await unitArray.push(new FormGroup({
          name: new FormControl((unit && unit.name) ? unit.name : unit.name),
          _id: new FormControl((unit && unit._id) ? unit._id : unit._id),
          submissionType: new FormControl((!unit && !unit.submissionType) ? 'Summative' : (unit.submissionType == 'Summitive') ? 'Summative' : unit.submissionType),
          listItem: new FormControl((unit && unit.listItem) ? unit.listItem : []),
          decision: new FormControl((unit && unit.decision) ? unit.decision : ''),
          listItem1: new FormControl((unit && unit.listItem) ? unit.listItem1 : ''),
          listState: new FormControl((unit && unit.listItem) ? unit.listState : ''),
          // unitId: new FormControl(exitsUnit ? exitsUnit[index].unitId : unit._id),
          // unitInput: new FormControl(exitsUnit ? exitsUnit[index].unitInput : ''),
        }))
      })
      return unitArray;
    } else {
      return [this.formBuilder.group({
        name: new FormControl(''),
        _id: new FormControl(''),
        submissionType: new FormControl('Summative'),
        listItem: new FormControl([]),
        decision: new FormControl(''),
        listItem1: new FormControl(''),
        listState: new FormControl(''),
      })]
    }
  }



  get actionsDetails() { return <FormArray>this.documentForm.get('actions'); }
  multipleActions(data?) {

    if (data && data.length) {
      let unitArray = []
      _.forEach(data, async (unit) => {
        await unitArray.push(new FormGroup({
          action: new FormControl(unit && unit.action ? unit.action : ''),
          targetDate: new FormControl(unit && unit.targetDate ? new Date(unit.targetDate) : ''),
          completeDate: new FormControl(unit && unit.completeDate ? new Date(unit.completeDate) : ''),
        }))
      })
      return unitArray;
    } else {
      return [this.formBuilder.group({
        action: new FormControl(''),
        targetDate: new FormControl(''),
        completeDate: new FormControl(''),
      })]
    }

  }

  removeAction(i) {
    const control = <FormArray>this.documentForm.controls.actions;
    console.log("controlll => ", control);
    control.removeAt(i)
  }
  addAction() {
    const control = <FormArray>this.documentForm.controls.actions;
    control.push(
      this.formBuilder.group({
        action: new FormControl(''),
        targetDate: new FormControl(''),
        completeDate: new FormControl(''),
      })
    )
  }

  // Utility


  updateData(assignment) {
    console.log("UPDATING DATA = ", assignment)
    console.log("Emitting event getLearnersFromComponent with learners = ", assignment);
    // this.getLearnersFromComponent.emit({ learners })
    this.dataSource = new MatTableDataSource(assignment);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    console.log("DATASOURCE", this.dataSource)
    console.log("SETTING SORT TO = ", this.dataSource.sort)
    console.log("SETTING paginator TO = ", this.dataSource.paginator)

  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }


  handleSnackBar(data) {
    this.openSnackBar(data.msg, data.button);
  }
  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

  addSignature(formType, fomrControl) {


    this.openDialog(SignaturePadComponent).subscribe((data) => {
      console.log("data of sign", data);
      if (data == undefined) return

      let sign = data

      if (formType == 'documentForm') {

        if (fomrControl == 'internalSign') {
          this.internalSign = true
          this.documentForm.patchValue({
            internalSign: sign
          })
        }
        if (fomrControl == 'assessorSign') {
          this.assessorSign = true
          this.documentForm.patchValue({
            assessorSign: sign
          })
        }
        if (fomrControl == 'leadSign') {
          this.leadSign = true
          this.documentForm.patchValue({
            leadSign: sign
          })
        }
      }
    })

  }

  dateChanged(event, type) {
    console.log("DATE CHANGED EVENT", event, type)
    //console.log('event.getDate()', event.value.getDate(), event.value.getMonth() + 1, event.value.getFullYear())
    //let temp = event.value.getDate() + "/" + (event.value.getMonth() + 1) + "/" + event.value.getFullYear()

    console.log("this.documentForm", this.documentForm)
  }


  openDialog(someComponent, data = {}): Observable<any> {
    console.log("OPENDIALOG", "DATA = ", data);
    const dialogRef = this.dialog.open(someComponent, {
      data, maxWidth: '100vw',
      maxHeight: '100vh',
      height: '100%',
      width: '100%'
    });
    return dialogRef.afterClosed();
  }

  compareObjects(o1: any, o2: any): boolean {
    // console.log("compareObjects called", o1._id, o2._id)
    if (o1 && o2) {
      return o1._id === o2._id;
    }

  }



  onChangeEventOther(value, formGroup, formControl) {
    // onChangeEvent(value, formGroup, formControl) {
    // console.log(formControl, formGroup);
    if (formGroup == 'documentForm') {
      this.documentForm.get(formControl).setValue(value);
    }
  }

  // API CALL


  /**
   * @param jobId 
   * Get all learners list
   */
  getLearners(jobId) {
    this.loading = true
    // this.gettingLearners = true
    this._learnerService.getLearnersByJobId(jobId).subscribe(responseLearner => {
      this.allLearners = responseLearner;
      // this.gettingLearners = false
      console.log("***this.allLearners in job", this.allLearners);
      console.log("what is the value of edit", this.isEdit);
      this.loading = false
      //if (this.isEdit == false) {
      //  this.createLearnerForm(this.allLearners)
      //}
    })
  }

  getJobDetails() {
    this.loading = true
    this.jobService.getJobById(this.jobId).subscribe((response) => {
      console.log("response of single job", response);
      this.singleJob = response.data[0]
      this.iqaVerification.controls.programmeTitle.setValue(this.singleJob.course.title)
      this.iqaVerification.controls.assignmentTitle.setValue(this.singleJob.title)
      this.instructorsList = response.data[0].instructors
      this.courseType = response.data[0].course.type
      this.courseId = response.data[0].course._id
      if (this.courseType != 'Level2') {
        //this.getAssignmentOfJob()
        this.getUnits()
      } else {
        this.getLevel2Units()
      }

      if (this.isEdit == false) {
        this.iqaVerification.controls.unitName.setValue(this.unitString)
        console.log("call this first if cond", this.singleJob)
        if (response.data[0].samples && !response.data[0].samples.length) {
          this.isDisplay = false
        } else {
          this.isDisplay = true
        }
        this.createLearnerForm(response.data[0].samples)
        response.data[0].instructors.forEach((inst) => {
          if (inst.role == 'trainer') {
            this.selectedAssessors.push(inst)
            this.displayAssessor.push(inst)
          }
          if (inst.role == 'IQA') {
            // this.selectedVerifieres.push(inst)
            this.displayVerifier.push(inst)
          }

        })
        this.iqaVerification.controls.assessor.setValue(this.selectedAssessors)
        this.iqaVerification.controls.verifier.setValue(this.selectedVerifieres)

      } else {
        console.log("else part for details", this.singleJob)
        response.data[0].instructors.forEach((inst) => {
          if (inst.role == 'trainer') {
            // this.selectedAssessors.push(inst._id)
            this.displayAssessor.push(inst)
          }
          if (inst.role == 'IQA') {
            // this.selectedVerifieres.push(inst._id)
            this.displayVerifier.push(inst)
          }
        })

        // let elementValue = this.editDetails.details.learnerForm.learners
        // let flagValue = false

        let elementValue = this.editDetails.details.learnerForm.learners
        let flagValue = false
        for (var i = 0; i < elementValue.length; i++) {
          // let temp = Object.keys(elementValue[i])
          // let tempAns = Object.values(elementValue[i]).length
          if (elementValue[i]._id === "") {
            flagValue = true;
            break;
          }
        }
        if (flagValue) {
          console.log("flag value after ", flagValue)
          this.createLearnerForm(response.data[0].samples)
        } else {
          console.log("this is for false value", flagValue);

        }

      }
      // console.log("display list ", this.displayAssessor, this.displayVerifier)
      this.loading = false
      this.getUserRoleJobWise()
    }, error => {
      this.loading = false
      console.log("error while get single job details", error);

    })




  }


  getUserRoleJobWise() {
    this.currentUser = JSON.parse(localStorage.getItem("currentUser"));
    console.log("current users ..........1 assement", this.currentUser)

    let roleUser = []
    if (this.currentUser) {
      roleUser.push(this.currentUser)
      console.log("current users ..........2 assement", this.singleJob.instructors)

      let jobUsers = _.intersectionBy(this.singleJob.instructors, roleUser, '_id')

      if (jobUsers && jobUsers.length) {

        if (jobUsers[0].role == "IQA") {
          this.isIQA = true
          this.iqaVerification.enable()
          this.learnerForm.enable()
          this.documentForm.enable()
        }
        else {
          this.isTrainer = true
          this.iqaVerification.disable()
          this.learnerForm.disable()
          // this.documentForm.disable()

        }

      }
      console.log("current users ..........3 assement", jobUsers)

    }

  }


  getUnits() {
    this.loading = true
    console.log("what is the course id", this.courseId);
    // console.log("what is the value of dedfault vaar=======", this.defaultUnit);

    this.unitService.getUnits(this.courseId).subscribe(res => {
      this.unitList = res;
      console.log("units list by course id", this.unitList)

      // this.createLearnerForm(this.allLearners, this.unitList)
      if (this.isEdit == false) {
        //this.createLearnerForm(this.allLearners)
        this.unitString = Array.prototype.map.call(this.unitList, function (item) { return item.unitNo; }).join(",");
        this.iqaVerification.controls.unitName.setValue(this.unitString)
      }
      this.loading = false
    })

  }

  editDateReturnTargetDate(value) {
    // console.log("value in target date===>", value);
    return value.value.targetDate
  }
  editDateReturnCompleteDate(value) {
    return value.value.completeDate
  }

  /**
   * Level2 jobs units list with sessions
   */
  getLevel2Units() {
    this.unitList = []

    this.unitService.getUnits(this.courseId).subscribe(res => {
      console.log("response of all status", res);
      let unitArray = []
      let newArray = res.filter((o) => {
        if (o.title == 'Track Maintenance' || o.title == 'Technical Certificate') {
          unitArray.push(o)
        }
      })
      console.log("display unit array", unitArray);
      // let finalArray = []

      unitArray.forEach((item) => {
        // let obj = {
        //   _id: item.title,
        //   session: []
        // }
        let obj = {
          _id: item._id,
          title: item.title + ": Unit-" + item.unitNo,
          unitNo: item.unitNo
        }
        // let index = finalArray.findIndex(x => x._id === item.title);
        let index = this.unitList.findIndex(function (o) { return o._id == item._id })
        console.log("index of this element", index);
        if (index == -1) {
          this.unitList.push(obj)
        }
      })
      if (this.isEdit == false) {
        //this.createLearnerForm(this.allLearners)
        this.unitString = Array.prototype.map.call(this.unitList, function (item) { return item.unitNo; }).join(",");
        this.iqaVerification.controls.unitName.setValue(this.unitString)
      }
    })

  }


  /**
   * Add or edit iqa form
   */
  submitIqaForm() {
    this.loading = true
    console.log("first form value", this.iqaVerification.value);

    console.log("second form value", this.learnerForm.value);


    console.log("final form value", this.documentForm.value);

    if (this.isEdit == true) {


      let obj = {
        metaObj: {
          title: 'IQA',
        },
        jobId: this.jobId,
        onModel: 'job',
        documentMetaId: this.editDetails.documentMetaId._id,
        documentId: this.editDetails._id,
        details: {}
      }

      let details = {
        iqaVerification: this.iqaVerification.value,
        learnerForm: this.learnerForm.value,
        documentForm: this.documentForm.value
      }
      obj['details'] = details
      console.log("this is for edit ", obj);

      this.documentService.updateForm(obj).subscribe((response) => {
        console.log("response of iqa form", response);
        this.handleSnackBar({ msg: "Document saved successfully!", button: "Ok" });
        // this.editDetails = {}
        this.getIqaFormValue()
        this.loading = false
        // this.router.navigate(['/jobs/' + this.jobId], { queryParams: { courseType: this.courseType, currentTab: 6 } })
      }, error => {
        console.log("error while update form", error);
        this.loading = false
        this.handleSnackBar({ msg: "Something went wrong!", button: "Ok" });
      })

    } else {
      let obj = {
        metaObj: {
          title: 'IQA',
        },
        jobId: this.jobId,
        onModel: 'job',
        details: {}
      }

      let details = {
        iqaVerification: this.iqaVerification.value,
        learnerForm: this.learnerForm.value,
        documentForm: this.documentForm.value
      }
      obj['details'] = details
      console.log("this is for first time add", obj);

      this.documentService.addDocument(obj).subscribe((response) => {
        console.log("document resposne of iqa form", response);
        this.handleSnackBar({ msg: "Document saved successfully!", button: "Ok" });
        this.editDetails = {}
        this.getIqaFormValue()
        this.loading = false
        // this.router.navigate(['/jobs/' + this.jobId], { queryParams: { courseType: this.courseType, currentTab: 6 } })
      }, error => {
        console.log("error while add iqa form", error);
        this.loading = false
        this.handleSnackBar({ msg: "Something went wrong!", button: "Ok" });
      })
    }
  }


  /**
   * Get Iqa form details
   */
  getIqaFormValue() {
    if (this.jobId) {
      this.loading = true
      this.documentService.getIqaFormValue(this.jobId).subscribe((response) => {
        console.log("response of form value of assesment form", response);
        if (response && response.length) {


          this.docId = response[0]._id
          let mainArray = response

          let element = mainArray.filter((x) => x.details.iqaVerification.assignmentId == this.assignmentId)
          console.log("what is the find element", element);
          if (element && element.length) {
            this.editDetails = element[0]
            this.isEdit = true
            this.unitTitle = (element[0].details.iqaVerification.unitName)
            this.assignmentTitle = element[0].details.iqaVerification.assignmentTitle
            this.assessorNames = element[0].details.iqaVerification.assessor
            this.selectedAssessors = element[0].details.iqaVerification.assessor
            this.IQANames = element[0].details.iqaVerification.verifier
            this.selectedVerifieres = element[0].details.iqaVerification.verifier
            this.createForm(element[0].details.iqaVerification)
            //this.iqaVerification.controls.unitName.setValue(this.unitTitle)
            // this.allLearners = JSON.stringify(element[0].details.learnerForm.learners)
            // console.log("all learner array from database", this.unitTitle);
            // console.log("assesment form value of iqa", this.);

            this.allLearners = []
            this.createLearnerForm(element[0].details.learnerForm.learners)
            if (element[0].details.documentForm) {

              let data = element[0].details.documentForm

              if (data && data.internalSign != '') {
                this.internalSign = true
              }
              if (data && data.assessorSign != '') {
                this.assessorSign = true
              }
              if (data && data.leadSign != '') {
                this.leadSign = true
              }

              this.createFinalForm(element[0].details.documentForm)
            }


          }
        }
        this.loading = false
      }, error => {
        this.loading = false
        console.log("error while get form value", error);

      })
    }
  }



  //Download Function
  async downloadIQAAssessment() {
    this.loading = true
    // let obj = {
    //   docId: this.docId,
    //   type: 'IQAassessment'
    // }
    let obj = {
      metaObj: {
        title: 'IQA',
      },
      jobId: this.jobId,
      onModel: 'job',
      documentMetaId: this.editDetails.documentMetaId._id,
      documentId: this.editDetails._id,
      details: {}
    }
    let details = {
      iqaVerification: this.iqaVerification.value,
      learnerForm: this.learnerForm.value,
      documentForm: this.documentForm.value
    }
    obj['details'] = details



    this.documentService.download(obj).subscribe((res) => {
      console.log("res.data", res.data.data.data)
      let byteArray = new Uint8Array(res.data.data.data);
      console.log("======byteArray =======", byteArray)
      let blob = new Blob([byteArray], { type: 'application/pdf' });
      console.log("blobblobblobblobblob", blob)
      let location = []
      this.singleJob.clients.forEach((item) => {
        location.push(item.location.title)
      })
      let title = 'Assessment Decision_' + location.join('-') + '_' + moment(new Date).format("DD-MM-YYYY")
      saveAs(blob, title);
      this.loading = false
    })

  }


  async getBase64ImageFromUrl(imageUrl) {
    let res = await fetch(imageUrl);
    let blob = await res.blob();

    return new Promise((resolve, reject) => {
      let reader = new FileReader();
      reader.addEventListener("load", function () {
        resolve(reader.result);
      }, false);

      reader.onerror = () => {
        return reject(this);
      };
      reader.readAsDataURL(blob);
    })
  }
}